var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('apexchart',{ref:"trainingChart",attrs:{"type":"line","height":"400","options":_vm.chartOptions,"series":_vm.series}}),_c('h5',{staticStyle:{"display":"none"}},[_vm._v(_vm._s(_vm.trainingId)+" "+_vm._s(_vm.timeMinutes)+" "+_vm._s(_vm.iapValue))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }